import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "bootstrap-icons/font/bootstrap-icons.css";
import { Button } from 'react-bootstrap';
import React, { useEffect, useState } from 'react'
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Alert from 'react-bootstrap/Alert';
import { useNavigate } from "react-router-dom";

const CancelSubscription = () => {
    const [cancelMessage, setCancelMessage] = useState('');
    const stripeurl = 'https://g6glhobkn3.execute-api.ca-central-1.amazonaws.com/top'
    const navigate = useNavigate();

    const cancelSubscription = async () => {
        const user = await Auth.currentAuthenticatedUser();

        fetch(stripeurl + '/cancel-subscription', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': user.signInUserSession.idToken.jwtToken
            }
        })
            .then(response => response.json())
            .then(response => {
                setCancelMessage('You successfuly canceled your subscription!');
                console.log(response);
            });
    };
    return (
        <Container>
            <br />
            <h3>Are you sure you want to cancel your subscription?</h3>
            {!cancelMessage && (
                <Row>
                    <Col className="d-flex justify-content-end" >
                        <Nav.Link>
                            <Button variant="danger" className='btn-lg' onClick={() => cancelSubscription()} >Yes</Button>
                        </Nav.Link>
                        <Nav.Link as={Link} to={'/'}>
                            <Button variant="primary" className='btn-lg'>No</Button>
                        </Nav.Link>
                    </Col>
                </Row>
            )}
            <Row>
                {cancelMessage && (
                    <Alert key="success" variant="success">
                        {cancelMessage}
                    </Alert>
                )}
            </Row>
        </Container>
    );
};

export default CancelSubscription;
